import { Icon, Text } from '@kanda-libs/ks-design-library';
import { KandaEtikaBadge } from 'components';

import { HEADER_CLASS_NAMES, HEADER_PROPS, PROVIDERS } from './constants';

interface HeaderProps {
  isLoading?: boolean;
  tradingName?: string;
  provider?: string;
  isExampleJob?: boolean;
}

const Header = ({
  isLoading = false,
  tradingName = '',
  provider = 'omni',
  isExampleJob = false,
}: HeaderProps) => {
  const innerItemProps = { isLoading };

  const providerName = PROVIDERS[provider];

  const isEtika = provider === 'etika' && !isExampleJob;

  const titleProps = isEtika ? HEADER_PROPS.etikaTitle : HEADER_PROPS.title;

  return (
    <div className={HEADER_CLASS_NAMES.container}>
      {isEtika ? <KandaEtikaBadge /> : null}
      <Text {...titleProps} {...innerItemProps} isLoading={isLoading} />
      <div className={HEADER_CLASS_NAMES.descriptionWrapper}>
        <span className={HEADER_CLASS_NAMES.description}>
          <Text
            {...HEADER_PROPS.description.otherProps}
            {...innerItemProps}
            isLoading={isLoading}
            text={
              <>
                {HEADER_PROPS.description.textLine1}
                <span className={HEADER_CLASS_NAMES.bold}>
                  {isExampleJob ? 'Example finance ltd' : providerName}
                </span>
                {HEADER_PROPS.description.textLine2}
                <span className={HEADER_CLASS_NAMES.bold}>{tradingName}</span>
                {HEADER_PROPS.description.textLine3}
              </>
            }
          />
        </span>

        <Icon
          {...HEADER_PROPS.icon}
          {...innerItemProps}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

Header.displayName = 'ApplyForFinance-Desktop-Welcome-Header-view';

export default Header;
